define(['md5'], md5 => {
    return {
        pushSubscribtion: email => {
            if (window && window.wamf) {
                window.wamf.push('email', md5(email));
                window.wamf.send();
            }
        },
    };
});
